/**
 * Google Analytics 4 (GA4) Utility
 * Handles automatic page tracking and custom events
 */

/* global gtag */

/**
 * Initialize GA4 page view tracking
 * Call this once on app mount
 */
export const initializeGA4 = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    console.log('✅ GA4 initialized successfully');
  } else {
    console.warn('⚠️ GTAg not available - GA4 may not be properly loaded');
  }
};

/**
 * Track page view in GA4
 * Call this whenever the route changes
 * @param {string} pathname - The current page path
 * @param {string} pageName - Human-readable page name
 */
export const trackGA4PageView = (pathname, pageName = '') => {
  if (typeof window !== 'undefined' && window.gtag) {
    gtag('event', 'page_view', {
      page_path: pathname,
      page_title: pageName || document.title,
      send_page_view: true,
    });
    console.log('📊 GA4 Page view tracked:', pageName || pathname);
  } else {
    console.warn('⚠️ GTAg not available - page view not tracked');
  }
};

/**
 * Track custom event in GA4
 * @param {string} eventName - Name of the event
 * @param {Object} eventData - Event data object
 */
export const trackGA4Event = (eventName, eventData = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    gtag('event', eventName, eventData);
    console.log('📊 GA4 Event tracked:', eventName, eventData);
  } else {
    console.warn('⚠️ GTAg not available - event not tracked:', eventName);
  }
};

/**
 * Track conversion event in GA4
 * @param {string} conversionName - Name of the conversion
 * @param {number} value - Conversion value
 * @param {string} currency - Currency code (e.g., 'INR')
 */
export const trackGA4Conversion = (conversionName, value = 1, currency = 'INR') => {
  if (typeof window !== 'undefined' && window.gtag) {
    gtag('event', conversionName, {
      value: value,
      currency: currency,
    });
    console.log('✅ GA4 Conversion tracked:', conversionName, value, currency);
  } else {
    console.warn('⚠️ GTAg not available - conversion not tracked:', conversionName);
  }
};

export default {
  initializeGA4,
  trackGA4PageView,
  trackGA4Event,
  trackGA4Conversion,
};
